module.exports = __webpack_public_path__ + "img/bear2.371f9853.svg";